import React, { useState } from 'react';
import { bankLabel } from '../utils/bank';
import './PayTicketDetailModal.css';

// Detail d'une fiche pour "Pay Ticket" (Central) — different de
// TicketReceiptModal.jsx (lecture seule, product_code/numbers/amount) : ici
// chaque ligne porte deja `gain`/`won` (calcules cote serveur), + le numero
// gagnant du tirage et le statut de paiement, pour l'ecran complet en un seul
// appel (cf. api/payTicket.js:searchPayTickets). `onPay(ticketId)` fait
// l'appel reseau ; le flux Payer -> Confirmer est en 2 clics (demande
// explicite), pas un window.confirm() natif.
const PayTicketDetailModal = ({ ticket, onClose, onPay }) => {
  const [confirming, setConfirming] = useState(false);
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setPaying(true);
    setError('');
    try {
      await onPay(ticket.id);
      setConfirming(false);
    } catch (err) {
      setError('Paiement impossible.');
    } finally {
      setPaying(false);
    }
  };

  const canPay = !ticket.is_paid && ticket.is_winner;

  return (
    <div className="ptm-overlay">
      <div className="ptm-modal">
        <div className="ptm-header">
          <span className="ptm-title">Ticket</span>
          <button className="ptm-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="ptm-body">
          <div className="ptm-bank-box">
            <strong>Banque:</strong> {bankLabel(ticket.bank_seq, ticket.bank_name)}
          </div>

          <div className="ptm-info-grid">
            <span><strong>Date:</strong> {ticket.date}</span>
            <span><strong>Heure:</strong> {ticket.time}</span>
            <span><strong>Sequence:</strong> {ticket.sq ?? '—'}</span>
            <span><strong>Type de Doc.:</strong> {ticket.was_offline ? 'L' : 'O'}</span>
          </div>

          <div className="ptm-divider" />

          <div className="ptm-tags-row">
            <span className="ptm-tag">
              <span className="ptm-tag-label">Loterie:</span> {ticket.tirage_code}|{ticket.tirage_name}
            </span>
            <span className="ptm-tag ptm-tag-narrow">
              <span className="ptm-tag-label">Ticket:</span> {ticket.no ?? '—'}
            </span>
          </div>

          {ticket.winning_number && (
            <p className="ptm-winning-line">
              Numero gagnant : {ticket.winning_number.numbers}
              {ticket.winning_number.win4 ? ` / Win4 : ${ticket.winning_number.win4}` : ''}
            </p>
          )}

          <table className="ptm-table">
            <thead>
              <tr><th>Produit</th><th>Numero</th><th>Mise</th><th>Gagne</th></tr>
            </thead>
            <tbody>
              {ticket.lines.map((line, i) => (
                <tr key={i} className={line.won ? 'ptm-line-won' : ''}>
                  <td>{line.product_abbr}</td>
                  <td>{line.numbers}</td>
                  <td className="ptm-amount">${Number(line.amount).toFixed(2)}</td>
                  <td className="ptm-amount">{line.won ? `$${Number(line.gain).toFixed(2)}` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="ptm-total-bar">
            Total mise: ${Number(ticket.total_amount).toFixed(2)} — Total gagne: ${Number(ticket.total_gain).toFixed(2)}
          </div>

          {ticket.is_paid && (
            <p className="ptm-paid-badge">Deja payee le {ticket.paid_at}.</p>
          )}
          {!ticket.is_paid && !ticket.is_winner && (
            <p className="ptm-no-win-msg">Cette fiche n'a rien gagne — rien a payer.</p>
          )}
          {confirming && (
            <p className="ptm-confirm-msg">
              Confirmer le paiement de ${Number(ticket.total_gain).toFixed(2)} pour cette fiche ?
            </p>
          )}
          {error && <p className="ptm-error">{error}</p>}
        </div>

        <div className="ptm-footer">
          <button className="ptm-close-action" onClick={onClose}>Fermer</button>
          {canPay && !confirming && (
            <button className="ptm-pay-action" onClick={() => setConfirming(true)}>Payer</button>
          )}
          {canPay && confirming && (
            <>
              <button className="ptm-cancel-action" onClick={() => setConfirming(false)} disabled={paying}>
                Annuler
              </button>
              <button className="ptm-confirm-action" onClick={handleConfirm} disabled={paying}>
                {paying ? '...' : 'Confirmer le paiement'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PayTicketDetailModal;
